import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyProvider } from "@/context/CompanyContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import EmployeesPage from "@/pages/EmployeesPage";
import CalculatorPage from "@/pages/CalculatorPage";
import DeclarationsPage from "@/pages/DeclarationsPage";
import DeclarationDetailPage from "@/pages/DeclarationDetailPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

const ThemedToaster = () => {
  const { theme } = useTheme();
  return <Toaster position="top-right" richColors theme={theme} />;
};

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route
                element={
                  <Protected>
                    <CompanyProvider>
                      <Layout />
                    </CompanyProvider>
                  </Protected>
                }
              >
                <Route path="/" element={<DashboardPage />} />
                <Route path="/salaries" element={<EmployeesPage />} />
                <Route path="/simulateur" element={<CalculatorPage />} />
                <Route path="/declarations" element={<DeclarationsPage />} />
                <Route path="/declarations/:id" element={<DeclarationDetailPage />} />
                <Route path="/parametres" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <ThemedToaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
